import { connect } from 'react-redux'
import { get } from 'lodash'
import { reduxForm } from 'redux-form'
import SendAnalyticsForm from './SendAnalyticsEventForm'

const stateToProps = ({ form }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    ...otherProps.initialValues,
  },
})

const dispatchToProps = {}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(SendAnalyticsForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendAnalyticsEvent/SendAnalyticsEventForm.container.js